export const NODE_NAME = 'table_cell';
